import { Component } from '@angular/core';
import AppValues from 'src/app/common/app.values';

import { FilePermissions } from 'src/app/swagger-api';
import { ActivitiesBaseComponent } from '../../activities.base.service';

@Component({
  selector: 'app-activities-permission',
  templateUrl: './activities-permission.component.html',
  styleUrls: ['./activities-permission.component.scss'],
})
export class ActivitiesPermissionChangedComponent extends ActivitiesBaseComponent {
  public readonly OWNER: string = FilePermissions.Owner;
  public readonly PERMISSION_READER: string = AppValues.PERMISSION_READER;
  public readonly PERMISSION_OWNER: string = AppValues.PERMISSION_OWNER;
}
